import { ActionStatus } from '@pixacare/shared';
import { SyncActionState } from '@shared/models/sync/sync-action-state';

const isActive = (status: ActionStatus): boolean =>
  status === ActionStatus.WAITING || status === ActionStatus.IN_PROGRESS;

// Rolls the children's states up to a parent state, generically (no business/transport knowledge):
// any error wins, then any still-running keeps it in progress (an active sync takes priority over
// an interrupted sibling), then any interrupted session, otherwise everything succeeded. Progress
// is the plain sum of the children's abstract done/total — each child's progress is already the
// unit the sync-center renders.
export const rollupSyncActionState = (states: SyncActionState[]): SyncActionState => {
  let status;
  const hasError = states.some((state) => state.status === ActionStatus.ERROR);
  const inProgress = states.some((state) => isActive(state.status));
  const interrupted = states.some((state) => state.status === ActionStatus.INTERRUPTION);

  if (hasError) {
    status = ActionStatus.ERROR;
  } else if (inProgress) {
    status = ActionStatus.IN_PROGRESS;
  } else if (interrupted) {
    status = ActionStatus.INTERRUPTION;
  } else {
    status = ActionStatus.SUCCESS;
  }

  return {
    status,
    progress: {
      done: states.reduce((total, state) => total + state.progress.done, 0),
      total: states.reduce((total, state) => total + state.progress.total, 0),
    },
  };
};
